var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container-fluid" },
    [
      _c("loading", {
        attrs: { active: _vm.isLoading, loader: "dots" },
        on: {
          "update:active": function ($event) {
            _vm.isLoading = $event
          },
        },
      }),
      _c("div", { staticClass: "card search-card" }, [
        _c("div", { staticClass: "card-body" }, [
          _c("div", { staticClass: "form-row" }, [
            _c("div", { staticClass: "col-sm-3 col-md-3" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", { attrs: { for: "" } }, [_vm._v("時段")]),
                  _c(
                    "el-select",
                    {
                      staticStyle: { display: "block" },
                      attrs: { placeholder: "請選擇", clearable: "" },
                      model: {
                        value: _vm.search.TimePeriod,
                        callback: function ($$v) {
                          _vm.$set(_vm.search, "TimePeriod", $$v)
                        },
                        expression: "search.TimePeriod",
                      },
                    },
                    _vm._l(_vm.timePeriodOptions, function (option) {
                      return _c("el-option", {
                        key: option.Value,
                        attrs: { label: option.Text, value: option.Value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "col-sm-3 col-md-3" }, [
              _c("div", { staticClass: "form-group" }, [
                _c("label", { attrs: { for: "" } }, [_vm._v("應徵職務")]),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.trim",
                      value: _vm.search.ManpowerDemandName,
                      expression: "search.ManpowerDemandName",
                      modifiers: { trim: true },
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text", placeholder: "請輸入關鍵字" },
                  domProps: { value: _vm.search.ManpowerDemandName },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.search,
                        "ManpowerDemandName",
                        $event.target.value.trim()
                      )
                    },
                    blur: function ($event) {
                      return _vm.$forceUpdate()
                    },
                  },
                }),
              ]),
            ]),
            _c("div", { staticClass: "col-sm-3 col-md-3" }, [
              _c("div", { staticClass: "form-group" }, [
                _c("label", { attrs: { for: "" } }, [_vm._v("招募窗口")]),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.trim",
                      value: _vm.search.ContactPerson,
                      expression: "search.ContactPerson",
                      modifiers: { trim: true },
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text", placeholder: "請輸入關鍵字" },
                  domProps: { value: _vm.search.ContactPerson },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.search,
                        "ContactPerson",
                        $event.target.value.trim()
                      )
                    },
                    blur: function ($event) {
                      return _vm.$forceUpdate()
                    },
                  },
                }),
              ]),
            ]),
            _c("div", { staticClass: "col-sm-3 col-md-3" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", { attrs: { for: "" } }, [_vm._v("面試狀態")]),
                  _c(
                    "el-select",
                    {
                      staticStyle: { display: "block" },
                      attrs: { placeholder: "請選擇", clearable: "" },
                      model: {
                        value: _vm.search.IsFinish,
                        callback: function ($$v) {
                          _vm.$set(_vm.search, "IsFinish", $$v)
                        },
                        expression: "search.IsFinish",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "全部", value: null },
                      }),
                      _c("el-option", {
                        attrs: { label: "未結案", value: false },
                      }),
                      _c("el-option", {
                        attrs: { label: "已結案", value: true },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "col-sm-3 col-md-3" }, [
              _c("div", { staticClass: "form-group" }, [
                _c("label", { attrs: { for: "" } }, [_vm._v("姓名")]),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.trim",
                      value: _vm.search.Name,
                      expression: "search.Name",
                      modifiers: { trim: true },
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text", placeholder: "請輸入關鍵字" },
                  domProps: { value: _vm.search.Name },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.search, "Name", $event.target.value.trim())
                    },
                    blur: function ($event) {
                      return _vm.$forceUpdate()
                    },
                  },
                }),
              ]),
            ]),
            _c("div", { staticClass: "col-sm-3 col-md-3" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-primary",
                  staticStyle: { "margin-top": "30px", "margin-right": "5px" },
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.getFlowManage()
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.i18n("Buttons.Search")) + " ")]
              ),
              _c(
                "button",
                {
                  staticClass: "btn btn-secondary",
                  staticStyle: { "margin-top": "30px", "margin-right": "5px" },
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      _vm.search = {}
                    },
                  },
                },
                [_vm._v(" 清除 ")]
              ),
            ]),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "text-right" }, [
        _vm._v(" 更新時間:" + _vm._s(_vm.reloadTime) + " "),
      ]),
      _c(
        "div",
        { staticClass: "fixed-list-item" },
        [
          _c("eva-icon", {
            attrs: { fill: "#000", name: "refresh-outline" },
            on: { click: _vm.reload },
          }),
        ],
        1
      ),
      _c("div", { staticClass: "text-right" }, [
        _c("span", { staticStyle: { position: "relative", bottom: "-30px" } }, [
          _vm._v("共計" + _vm._s(_vm.personList.length) + "人"),
        ]),
      ]),
      _c(
        "el-tabs",
        {
          on: { "tab-click": _vm.getFlowManage },
          model: {
            value: _vm.activeName,
            callback: function ($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName",
          },
        },
        [
          _c("el-tab-pane", { attrs: { label: "全部", name: "All" } }),
          _c("el-tab-pane", { attrs: { label: "IDL", name: "IDL" } }),
          _c("el-tab-pane", { attrs: { label: "DL", name: "DL" } }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "process-list" },
        _vm._l(_vm.personList, function (person, personIndex) {
          return _c("div", { key: personIndex, staticClass: "p-row" }, [
            _c(
              "div",
              { staticClass: "info" },
              [
                _c(
                  "el-tooltip",
                  {
                    attrs: {
                      effect: "dark",
                      content: person.Name,
                      placement: "top-start",
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "name-link",
                        class: {
                          female: person.Sex === "女",
                          male: person.Sex === "男",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.showDetailModal(person)
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(person.Name) + " ")]
                    ),
                  ]
                ),
                _c("div", { staticClass: "id" }, [_vm._v(_vm._s(person.IdNo))]),
                _c(
                  "el-tooltip",
                  {
                    staticStyle: { "margin-bottom": "5px" },
                    attrs: {
                      effect: "dark",
                      content: person.ManpowerDemandName,
                      placement: "top-start",
                    },
                  },
                  [
                    _c("span", { staticClass: "job" }, [
                      _vm._v(_vm._s(person.ManpowerDemandName)),
                    ]),
                  ]
                ),
                _vm._l(person.ExpireStatus, function (item, index) {
                  return _c(
                    "el-tag",
                    {
                      key: index,
                      attrs: {
                        type:
                          item === "超時" || item === "整體流程超時"
                            ? "danger"
                            : "warning",
                      },
                    },
                    [
                      _c("eva-icon", {
                        staticStyle: { position: "relative", top: "-2px" },
                        attrs: {
                          width: "20",
                          name: "alert-circle-outline",
                          fill: "#FF0000",
                        },
                      }),
                      _vm._v(_vm._s(item)),
                    ],
                    1
                  )
                }),
              ],
              2
            ),
            _c(
              "div",
              { staticClass: "flow" },
              [
                _c("ul", { staticClass: "flow-group" }, [
                  _c("li", { staticClass: "flow-item forbid" }, [
                    _c("span", { staticClass: "step-name" }, [_vm._v("報到")]),
                    _c("div", [
                      _vm._v(_vm._s(_vm._f("momentTime")(person.CheckInTime))),
                    ]),
                  ]),
                ]),
                _c(
                  "draggable",
                  {
                    staticClass: "flow-group",
                    attrs: {
                      "ghost-class": "ghost",
                      tag: "ul",
                      draggable: ".flow-item:not(.forbid)",
                      move: _vm.handleMove,
                    },
                    on: {
                      end: function ($event) {
                        return _vm.onEnd($event, person.Guid, personIndex)
                      },
                    },
                    model: {
                      value: person.Stages,
                      callback: function ($$v) {
                        _vm.$set(person, "Stages", $$v)
                      },
                      expression: "person.Stages",
                    },
                  },
                  _vm._l(person.Stages, function (step, stepIndex) {
                    return _c(
                      "div",
                      {
                        key: step.StageGuid,
                        staticClass: "flow-item",
                        class: {
                          undo: step.Status === 1,
                          meeting: step.Status === 2,
                          finish:
                            step.Status === 3 ||
                            person.FinishTime ||
                            step.IsDeleted,
                          forbid:
                            step.Status === 2 ||
                            step.Status === 3 ||
                            person.FinishTime ||
                            step.IsDeleted,
                        },
                      },
                      [
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "text",
                            attrs: {
                              effect: "dark",
                              content: step.Name,
                              placement: "top",
                            },
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "step-name",
                                class: { "line-through": step.IsDeleted },
                              },
                              [_vm._v(_vm._s(step.Name))]
                            ),
                          ]
                        ),
                        step.Type === 2
                          ? _c(
                              "el-select",
                              {
                                staticStyle: { width: "100px" },
                                attrs: {
                                  filterable: "",
                                  disabled:
                                    step.StartTime !== null || step.IsDeleted,
                                },
                                on: {
                                  "visible-change": function ($event) {
                                    return _vm.setTempSupervisor(
                                      $event,
                                      step.InterviewSupervisorGuid
                                    )
                                  },
                                  change: function ($event) {
                                    return _vm.changeSupervisor(
                                      $event,
                                      person.Guid,
                                      step.StageGuid,
                                      personIndex,
                                      stepIndex
                                    )
                                  },
                                },
                                model: {
                                  value: step.InterviewSupervisorGuid,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      step,
                                      "InterviewSupervisorGuid",
                                      $$v
                                    )
                                  },
                                  expression: "step.InterviewSupervisorGuid",
                                },
                              },
                              _vm._l(
                                _vm.supervisorList,
                                function (interviewPerson) {
                                  return _c("el-option", {
                                    key: interviewPerson.Value,
                                    attrs: {
                                      value: interviewPerson.Value,
                                      label: interviewPerson.Text,
                                    },
                                  })
                                }
                              ),
                              1
                            )
                          : _vm._e(),
                        _c(
                          "div",
                          [
                            step.Status !== 1
                              ? _c(
                                  "div",
                                  { staticClass: "time-wrap" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm._f("momentTime")(step.StartTime)
                                        ) +
                                        " "
                                    ),
                                    step.Name !== "報到"
                                      ? _c("span", [_vm._v("~")])
                                      : _vm._e(),
                                    step.Status === 2
                                      ? _c(
                                          "span",
                                          { staticStyle: { opacity: "0.6" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("momentTime")(
                                                  step.ExpectEndTime
                                                )
                                              )
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm._f("momentTime")(step.EndTime)
                                        ) +
                                        " "
                                    ),
                                    step.Status === 2
                                      ? _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              type: "danger",
                                              size: "mini",
                                              round: "",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.endArrange(
                                                  person.Guid,
                                                  personIndex,
                                                  step.StageGuid
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("結束")]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            !person.FinishTime && !step.IsDeleted
                              ? [
                                  step.CanStart
                                    ? _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            type: "primary",
                                            size: "mini",
                                            round: "",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.startArrange(
                                                person.Guid,
                                                personIndex,
                                                step.StageGuid
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("開始")]
                                      )
                                    : _vm._e(),
                                  step.Status === 1
                                    ? _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            type: "info",
                                            size: "mini",
                                            round: "",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.openPassModal(
                                                person.Guid,
                                                step.StageGuid,
                                                personIndex,
                                                step.Name
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("Pass")]
                                      )
                                    : _vm._e(),
                                  step.Status === 2
                                    ? _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            type: "warning",
                                            size: "mini",
                                            round: "",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.cancelArrange(
                                                person.Guid,
                                                personIndex,
                                                step.StageGuid
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("取消")]
                                      )
                                    : _vm._e(),
                                ]
                              : _vm._e(),
                            _vm._l(step.ExpireStatus, function (item, index) {
                              return _c(
                                "el-tag",
                                {
                                  key: index,
                                  attrs: {
                                    type:
                                      item === "超時" || item === "整體流程超時"
                                        ? "danger"
                                        : "warning",
                                  },
                                },
                                [
                                  _c("eva-icon", {
                                    staticStyle: {
                                      position: "relative",
                                      top: "-2px",
                                    },
                                    attrs: {
                                      width: "20",
                                      name: "alert-circle-outline",
                                      fill: "#FF0000",
                                    },
                                  }),
                                  _vm._v(_vm._s(item)),
                                ],
                                1
                              )
                            }),
                          ],
                          2
                        ),
                      ],
                      1
                    )
                  }),
                  0
                ),
                !person.FinishTime
                  ? _c("el-button", {
                      staticStyle: {
                        "vertical-align": "middle",
                        "margin-left": "5px",
                      },
                      attrs: { icon: "el-icon-plus", size: "mini", circle: "" },
                      on: {
                        click: function ($event) {
                          return _vm.selectStage(person, personIndex)
                        },
                      },
                    })
                  : _vm._e(),
                _c("ul", { staticClass: "flow-group" }, [
                  _c(
                    "li",
                    { staticClass: "flow-item" },
                    [
                      person.CancelReason == null
                        ? _c("span", { staticClass: "step-name" }, [
                            _vm._v("結案"),
                          ])
                        : person.CancelReason == "轉推薦"
                        ? _c("span", { staticClass: "step-name" }, [
                            _vm._v("轉推薦"),
                          ])
                        : _c("span", { staticClass: "step-name" }, [
                            _vm._v("強制結案"),
                          ]),
                      _c("br"),
                      person.FinishTime
                        ? _c("div", { staticClass: "time-wrap" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm._f("momentTime")(person.FinishTime)
                                ) +
                                " "
                            ),
                          ])
                        : _vm._e(),
                      !person.FinishTime
                        ? [
                            _vm.hasUndo(person.Stages)
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      type: "danger",
                                      size: "mini",
                                      round: "",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.showDangerEndModal(
                                          person,
                                          personIndex
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("強制結案")]
                                )
                              : _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      type: "primary",
                                      size: "mini",
                                      round: "",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.showEndModal(
                                          person,
                                          personIndex
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("結案")]
                                ),
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "primary",
                                  size: "mini",
                                  round: "",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.showTransferModal(
                                      person,
                                      personIndex
                                    )
                                  },
                                },
                              },
                              [_vm._v("轉推薦")]
                            ),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                ]),
              ],
              1
            ),
          ])
        }),
        0
      ),
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: {
            id: "alertModal",
            tabindex: "-1",
            "data-backdrop": "static",
          },
        },
        [
          _c("div", { staticClass: "modal-dialog modal-dialog-centered" }, [
            _c("div", { staticClass: "modal-content" }, [
              _vm._m(0),
              _c("div", { staticClass: "modal-body text-center" }),
              _c("div", { staticClass: "modal-footer" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary",
                    attrs: { type: "reset", "data-dismiss": "modal" },
                  },
                  [_vm._v(" 關閉 ")]
                ),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.cancel(_vm.currentPerson)
                      },
                    },
                  },
                  [_vm._v(" 確定 ")]
                ),
              ]),
            ]),
          ]),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: { id: "endModal", tabindex: "-1", "data-backdrop": "static" },
        },
        [
          _c("div", { staticClass: "modal-dialog modal-dialog-centered" }, [
            _c("div", { staticClass: "modal-content" }, [
              _vm._m(1),
              _c(
                "div",
                { staticClass: "modal-body" },
                [
                  _c("span", [_vm._v("處理內容")]),
                  _c("el-input", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      type: "textarea",
                      autosize: { minRows: 2, maxRows: 4 },
                      placeholder: "請輸入內容",
                      maxlength: "500",
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.cancelModal.FinishRemark,
                      callback: function ($$v) {
                        _vm.$set(_vm.cancelModal, "FinishRemark", $$v)
                      },
                      expression: "cancelModal.FinishRemark",
                    },
                  }),
                ],
                1
              ),
              _c("div", { staticClass: "modal-footer" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary",
                    attrs: { type: "reset", "data-dismiss": "modal" },
                  },
                  [_vm._v(" 取消 ")]
                ),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.finishArrange("normal")
                      },
                    },
                  },
                  [_vm._v(" 儲存 ")]
                ),
              ]),
            ]),
          ]),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: {
            id: "dangerEndModal",
            tabindex: "-1",
            "data-backdrop": "static",
          },
        },
        [
          _c("div", { staticClass: "modal-dialog modal-dialog-centered" }, [
            _c(
              "div",
              { staticClass: "modal-content" },
              [
                _c("ValidationObserver", {
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ handleSubmit }) {
                        return [
                          _c("div", { staticClass: "modal-header" }, [
                            _c("h5", { staticClass: "modal-title" }, [
                              _vm._v("是否強制結案"),
                            ]),
                          ]),
                          _c(
                            "div",
                            { staticClass: "modal-body" },
                            [
                              _c("span", [
                                _c("span", { staticClass: "mark" }, [
                                  _vm._v("*"),
                                ]),
                                _vm._v("結案原因"),
                              ]),
                              _c("ValidationProvider", {
                                staticClass: "w-100",
                                attrs: { name: "結案原因", rules: "required" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ errors }) {
                                        return [
                                          _c(
                                            "el-select",
                                            {
                                              staticStyle: { width: "100%" },
                                              attrs: { placeholder: "請選擇" },
                                              model: {
                                                value:
                                                  _vm.cancelModal.cancelReason,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.cancelModal,
                                                    "cancelReason",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "cancelModal.cancelReason",
                                              },
                                            },
                                            _vm._l(
                                              _vm.cancelReasonList,
                                              function (option) {
                                                return _c("el-option", {
                                                  key: option.Value,
                                                  attrs: {
                                                    label: option.Text,
                                                    value: option.Value,
                                                  },
                                                })
                                              }
                                            ),
                                            1
                                          ),
                                          errors[0]
                                            ? _c(
                                                "span",
                                                { staticClass: "text-danger" },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(errors[0]) +
                                                      " "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                              _c("br"),
                              _c("br"),
                              _c("span", [_vm._v("備註")]),
                              _c("el-input", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  type: "textarea",
                                  autosize: { minRows: 2, maxRows: 4 },
                                  placeholder: "請輸入內容",
                                  maxlength: "500",
                                  "show-word-limit": "",
                                },
                                model: {
                                  value: _vm.cancelModal.FinishRemark,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.cancelModal,
                                      "FinishRemark",
                                      $$v
                                    )
                                  },
                                  expression: "cancelModal.FinishRemark",
                                },
                              }),
                            ],
                            1
                          ),
                          _c("div", { staticClass: "modal-footer" }, [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-secondary",
                                attrs: {
                                  type: "reset",
                                  "data-dismiss": "modal",
                                },
                              },
                              [_vm._v(" 關閉 ")]
                            ),
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-primary",
                                attrs: { type: "button" },
                                on: {
                                  click: function ($event) {
                                    return handleSubmit(_vm.finishArrange)
                                  },
                                },
                              },
                              [_vm._v(" 確定 ")]
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ]),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: {
            id: "transferModal",
            tabindex: "-1",
            "data-backdrop": "static",
          },
        },
        [
          _c("div", { staticClass: "modal-dialog modal-dialog-centered" }, [
            _c(
              "div",
              { staticClass: "modal-content" },
              [
                _c("ValidationObserver", {
                  ref: "transferModalForm",
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ handleSubmit }) {
                        return [
                          _c("div", { staticClass: "modal-header" }, [
                            _c("h5", { staticClass: "modal-title" }, [
                              _vm._v("轉推薦"),
                            ]),
                          ]),
                          _c(
                            "div",
                            { staticClass: "modal-body" },
                            [
                              _c("div", [
                                _c("span", { staticClass: "mark" }, [
                                  _vm._v("*"),
                                ]),
                                _vm._v("職務"),
                              ]),
                              _c("ValidationProvider", {
                                staticClass: "w-100",
                                attrs: { name: "職務", rules: "required" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ errors }) {
                                        return [
                                          _c(
                                            "el-select",
                                            {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                filterable: "",
                                                clearable: "",
                                                placeholder: "請選擇",
                                              },
                                              model: {
                                                value:
                                                  _vm.transferModal
                                                    .ManpowerDemandNo,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.transferModal,
                                                    "ManpowerDemandNo",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "transferModal.ManpowerDemandNo",
                                              },
                                            },
                                            _vm._l(
                                              _vm.positionOptions,
                                              function (item) {
                                                return _c("el-option", {
                                                  key: item.Value,
                                                  attrs: {
                                                    label: item.Text,
                                                    value: item.Value,
                                                  },
                                                })
                                              }
                                            ),
                                            1
                                          ),
                                          errors[0]
                                            ? _c(
                                                "span",
                                                { staticClass: "text-danger" },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(errors[0]) +
                                                      " "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                              _c(
                                "div",
                                { staticStyle: { "margin-top": "10px" } },
                                [
                                  _c("span", { staticClass: "mark" }, [
                                    _vm._v("*"),
                                  ]),
                                  _vm._v("流程"),
                                ]
                              ),
                              _c("ValidationProvider", {
                                staticClass: "w-100",
                                attrs: { name: "流程", rules: "required" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ errors }) {
                                        return [
                                          _c(
                                            "el-select",
                                            {
                                              staticStyle: { width: "100%" },
                                              attrs: { placeholder: "請選擇" },
                                              model: {
                                                value:
                                                  _vm.transferModal
                                                    .BaseFlowGuid,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.transferModal,
                                                    "BaseFlowGuid",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "transferModal.BaseFlowGuid",
                                              },
                                            },
                                            _vm._l(
                                              _vm.flowOptions,
                                              function (item) {
                                                return _c("el-option", {
                                                  key: item.Value,
                                                  attrs: {
                                                    label: item.Text,
                                                    value: item.Value,
                                                    disabled: !item.IsEnabled,
                                                  },
                                                })
                                              }
                                            ),
                                            1
                                          ),
                                          errors[0]
                                            ? _c(
                                                "span",
                                                { staticClass: "text-danger" },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(errors[0]) +
                                                      " "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                              _c(
                                "div",
                                { staticStyle: { "margin-top": "10px" } },
                                [_vm._v("接待窗口")]
                              ),
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    filterable: "",
                                    clearable: "",
                                    placeholder: "請選擇窗口",
                                  },
                                  model: {
                                    value: _vm.transferModal.ContactPersonGuid,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.transferModal,
                                        "ContactPersonGuid",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "transferModal.ContactPersonGuid",
                                  },
                                },
                                _vm._l(_vm.contactOptions, function (item) {
                                  return _c("el-option", {
                                    key: item.Value,
                                    attrs: {
                                      label: item.Text,
                                      value: item.Value,
                                    },
                                  })
                                }),
                                1
                              ),
                              _c(
                                "div",
                                { staticStyle: { "margin-top": "10px" } },
                                [
                                  _c("span", { staticClass: "mark" }, [
                                    _vm._v("*"),
                                  ]),
                                  _vm._v("HR主管"),
                                ]
                              ),
                              _c("ValidationProvider", {
                                staticClass: "w-100",
                                attrs: { name: "HR主管", rules: "required" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ errors }) {
                                        return [
                                          _c(
                                            "el-select",
                                            {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                filterable: "",
                                                placeholder: "請選擇",
                                              },
                                              model: {
                                                value:
                                                  _vm.transferModal
                                                    .HrSupervisorGuid,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.transferModal,
                                                    "HrSupervisorGuid",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "transferModal.HrSupervisorGuid",
                                              },
                                            },
                                            _vm._l(
                                              _vm.contactOptions,
                                              function (item) {
                                                return _c("el-option", {
                                                  key: item.Value,
                                                  attrs: {
                                                    label: item.Text,
                                                    value: item.Value,
                                                  },
                                                })
                                              }
                                            ),
                                            1
                                          ),
                                          errors[0]
                                            ? _c(
                                                "span",
                                                { staticClass: "text-danger" },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(errors[0]) +
                                                      " "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                              _c(
                                "div",
                                { staticStyle: { "margin-top": "10px" } },
                                [_vm._v("面談主管")]
                              ),
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    filterable: "",
                                    clearable: "",
                                    placeholder: "請選擇窗口",
                                  },
                                  model: {
                                    value:
                                      _vm.transferModal.ManagerSupervisorGuid,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.transferModal,
                                        "ManagerSupervisorGuid",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "transferModal.ManagerSupervisorGuid",
                                  },
                                },
                                _vm._l(_vm.contactOptions, function (item) {
                                  return _c("el-option", {
                                    key: item.Value,
                                    attrs: {
                                      label: item.Text,
                                      value: item.Value,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                          _c("div", { staticClass: "modal-footer" }, [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-secondary",
                                attrs: {
                                  type: "reset",
                                  "data-dismiss": "modal",
                                },
                              },
                              [_vm._v(" 關閉 ")]
                            ),
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-primary",
                                attrs: { type: "button" },
                                on: {
                                  click: function ($event) {
                                    return handleSubmit(_vm.saveTransfer)
                                  },
                                },
                              },
                              [_vm._v(" 確定 ")]
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ]),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: { id: "passModal", tabindex: "-1", "data-backdrop": "static" },
        },
        [
          _c("div", { staticClass: "modal-dialog modal-dialog-centered" }, [
            _c("div", { staticClass: "modal-content" }, [
              _vm._m(2),
              _c("div", { staticClass: "modal-body" }, [
                _vm._v(" 是否確認pass"),
                _c(
                  "span",
                  { staticStyle: { "font-weight": "bold", color: "#ff0000" } },
                  [_vm._v(_vm._s(_vm.passItem.stepName))]
                ),
                _vm._v("階段? "),
              ]),
              _c("div", { staticClass: "modal-footer" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary",
                    attrs: { type: "reset", "data-dismiss": "modal" },
                  },
                  [_vm._v(" 取消 ")]
                ),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.pass()
                      },
                    },
                  },
                  [_vm._v("確定")]
                ),
              ]),
            ]),
          ]),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: { id: "stepModal", tabindex: "-1", "data-backdrop": "static" },
        },
        [
          _c("div", { staticClass: "modal-dialog modal-dialog-centered" }, [
            _c("div", { staticClass: "modal-content" }, [
              _vm._m(3),
              _c(
                "div",
                { staticClass: "modal-body" },
                [
                  _c("span", [_vm._v("階段")]),
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { placeholder: "請選擇" },
                      model: {
                        value: _vm.extraStage,
                        callback: function ($$v) {
                          _vm.extraStage = $$v
                        },
                        expression: "extraStage",
                      },
                    },
                    _vm._l(_vm.stageList, function (item) {
                      return _c("el-option", {
                        key: item.Value,
                        attrs: { label: item.Text, value: item.Value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c("div", { staticClass: "modal-footer" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary",
                    attrs: { type: "reset", "data-dismiss": "modal" },
                  },
                  [_vm._v(" 關閉 ")]
                ),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.addStage()
                      },
                    },
                  },
                  [_vm._v(" 確定 ")]
                ),
              ]),
            ]),
          ]),
        ]
      ),
      _c(
        "transition",
        {
          attrs: {
            name: "custom-classes-transition",
            "enter-active-class": "animated bounceInLeft",
            "leave-active-class": "animated bounceOutRight",
          },
        },
        [
          _vm.isShowDetail
            ? _c("div", { staticClass: "detail-modal" }, [
                _c("div", { staticClass: "detail-modal-inner" }, [
                  _c("div", { staticClass: "menu" }, [
                    _c("a", [
                      _c(
                        "span",
                        [
                          _c("eva-icon", {
                            attrs: { name: "person-outline", fill: "#FFF" },
                          }),
                          _vm._v(" 履歷 "),
                        ],
                        1
                      ),
                    ]),
                    _c(
                      "div",
                      {
                        staticClass: "close-show-detail",
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            _vm.isShowDetail = !_vm.isShowDetail
                          },
                        },
                      },
                      [
                        _c("eva-icon", {
                          attrs: {
                            name: "close-circle",
                            fill: "#FFF",
                            width: "50",
                            height: "50",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _c(
                    "div",
                    { staticClass: "page-wrap" },
                    [
                      _c(
                        "transition",
                        {
                          attrs: {
                            name: "custom-classes-transition",
                            "enter-active-class": "animated flipInY",
                          },
                        },
                        [
                          _c("perfect-scrollbar", { staticClass: "page" }, [
                            _c(
                              "section",
                              { staticClass: "page-inner" },
                              [
                                _c("div", { staticClass: "title" }, [
                                  _c(
                                    "div",
                                    { staticClass: "item text-center" },
                                    [_vm._v("履歷")]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "item text-right" },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "btn btn-outline-primary btn-sm",
                                          attrs: { type: "button" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.$common.downloadResumePDF(
                                                _vm.resumeDetail.ResumeType,
                                                _vm.resumeDetail.ResumeId
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v(" 下載 PDF ")]
                                      ),
                                    ]
                                  ),
                                ]),
                                _vm.resumeDetail.ResumeType === "IDL"
                                  ? _c("IdlResume", {
                                      attrs: {
                                        ResumeId: _vm.resumeDetail.ResumeId,
                                        ResumeType: "IDL",
                                      },
                                    })
                                  : _vm._e(),
                                _vm.resumeDetail.ResumeType === "DL"
                                  ? _c("DlResume", {
                                      attrs: {
                                        ResumeId: _vm.resumeDetail.ResumeId,
                                        ResumeType: "DL",
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ])
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-header" }, [
      _c("h5", { staticClass: "modal-title" }, [_vm._v("是否確定取消")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-header" }, [
      _c("h5", { staticClass: "modal-title" }, [_vm._v("結案")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-header" }, [
      _c("h5", { staticClass: "modal-title" }, [_vm._v("pass")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-header" }, [
      _c("h5", { staticClass: "modal-title" }, [_vm._v("加入階段")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }